import styled, { css } from "styled-components";
import { device } from "../../../../globalStyles/";
import { ButtonWrap } from "../../../Common";

export const Wrapper = styled.div`
  margin-top: 1rem;
  display: flex;
  position: relative;
  height: 500px;
`;

export const MapDropdownWrapper = styled.div`
  margin: 5px;
  box-shadow: -1px 2px 21px -10px rgba(49, 49, 49, 1);
`;

export const MapDropdownFlexWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: row;
  top: 10px;
  left: 10px;
`;

export const GPSReportHeaderContainer = styled.div`
  ${device.desktop} {
    display: flex;
    align-items: center;
  }
`;

export const GPSReportHeaderContentContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

export const GPSHeaderButtonWrap = styled(ButtonWrap)`
  width: 180px;
  margin-left: 10px;
  &.sharing {
    width: 38px;
  }
`;

export const MapBottomRightButtonWrapper = styled.div`
  position: absolute;
  bottom: 20px;
  right: 10px;
`;

export const MapCenterBottomRightButtonWrapper = styled.div`
  position: absolute;
  bottom: 75px;
  right: 10px;
`;

export const ListOuterWrapper = styled.div`
  padding: 1rem;
`;

export const ListInnerWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
`;

export const RangeWrapper = styled.div`
  margin: 15px 0;
  width: 100%;
  ${device.mobileL} {
    width: 50%;
    max-width: 225px;
  }
`;

export const DateBlockWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const DateBlockContainer = styled.div`
  padding: 8px 0 24px 0;
  ${device.mobileL} {
    display: flex;
    align-items: flex-end;
  }
`;

export const DateBlock = styled.div`
  padding: 8px;
  h5 {
    margin-bottom: 2px;
  }
`;

const VerticalBorderStyles = css`
  border-right: 1px solid lightgray;
  margin: 0 28px 15px;
  display: block;
`;

export const DateVerticalBorder = styled.div`
  ${VerticalBorderStyles}
  height: 42px;
`;

export const LogoVerticalBorder = styled.div`
  display: none;
  ${device.desktop} {
    ${VerticalBorderStyles}
    height: 58px;
  }
`;

export const DateBlockHeaderWrap = styled.div`
  display: flex;
  align-items: center;
  margin: 35px 0 10px;
`;

export const GPSBenchmarkButtonWrap = styled.div`
  height: 40px;
  display: flex;
  marginbottom: 1rem;
`;
